export default __webpack_public_path__ + "static/media/all.ebfafa8f.png";